import HTTPClient from '../common/http-client'

export const plusHubService = {
  getHubInfo,
  deleteDevice
}

function getHttpHubInfo() {
  return HTTPClient.getInstance().httpPlusHub
}
// ハブ情報を取得する
async function getHubInfo() {
  const res = await getHttpHubInfo().get('hub/getHubInfo')
  return res.data
}

// デバイスの削除
async function deleteDevice(uuid) {
  const res = await getHttpHubInfo().get('hubDevice/delete', {
    params: { uuid }
  })
  return res.data
}



// WEBPACK FOOTER //
// ./src/_services/plus-hub.service.js